import { api } from "./api";

const VIEW_KEY = (id) => `aduku_viewed_${id}`;
const VISIT_KEY = "aduku_visited_today";

function todayStr() {
    const d = new Date();
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

/**
 * Fire-and-forget view tracker. Throttled to once per browser session per listing.
 */
export async function trackView(listingId) {
    if (!listingId || typeof window === "undefined") return;
    try {
        if (sessionStorage.getItem(VIEW_KEY(listingId))) return;
        sessionStorage.setItem(VIEW_KEY(listingId), "1");
        await api.post(`/listings/${listingId}/track-view`);
    } catch { /* silent */ }
}

/**
 * Fire-and-forget click tracker — kind: "call" | "email" | "chat" | "share" | "whatsapp" | "other".
 * Not throttled; we want to count repeat clicks because they signal interest.
 */
export async function trackClick(listingId, kind = "other") {
    if (!listingId) return;
    try { await api.post(`/listings/${listingId}/track-click`, { kind }); } catch { /* silent */ }
}

/**
 * Site-wide visit. Throttled once per day per browser via localStorage.
 *
 * v78.58 — Funnel-fix P1. The old call was a fire-and-forget POST with no
 * payload, so the backend could only `$inc` a single counter. We now ship
 * path / referrer / UTM source/medium/campaign in the body so the new
 * /api/admin/visits/breakdown endpoint can finally answer "where is my
 * audience coming from". The backend reads country from the
 * Cloudflare `cf-ipcountry` edge header — we don't need to send it.
 */
export async function trackSiteVisit() {
    if (typeof window === "undefined") return;
    try {
        const stamp = localStorage.getItem(VISIT_KEY);
        if (stamp === todayStr()) return;
        localStorage.setItem(VISIT_KEY, todayStr());
        const sp = new URLSearchParams(window.location.search);
        const utm = {
            source: sp.get("utm_source") || "",
            medium: sp.get("utm_medium") || "",
            campaign: sp.get("utm_campaign") || "",
        };
        const referrer = (document.referrer || "").replace(window.location.origin, "");
        await api.post("/stats/visit", {
            path: window.location.pathname || "/",
            referrer,
            utm,
        });
    } catch { /* silent */ }
}
